import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LeafletModule } from '@asymmetrik/ngx-leaflet';
import { TranslateModule } from '@ngx-translate/core';
import { AccordionModule } from 'primeng/accordion';
import { NbSpinnerModule } from '@nebular/theme';
import { MapComponent } from './map.component';





@NgModule({
  declarations: [MapComponent],
  imports: [
    CommonModule,
    LeafletModule,
    AccordionModule,
    NbSpinnerModule,
    TranslateModule.forChild(),
  ],
  exports: [MapComponent]
})
export class MapModule { }
